import { immerable } from 'immer';
import type { PodcastEpisodeDTO } from '../dto/podcast-episode.dto.js';
import type { SpotlightDTO, SpotlightLinkEncodedDTO, SpotlightPreviewDTO } from '../dto/spotlight.dto.js';
import { isObjectIdStringified } from '../utils/index.js';
import { PodcastEpisode } from './podcast.model.js';

export class Spotlight implements SpotlightDTO {
  [immerable] = true;

  _id: string;
  createdAt?: Date;
  end: number;
  item: string | PodcastEpisode;
  start: number;
  type: 'link';
  uiConfig: {
    backgroundColor: string;
    name: string;
  };
  updatedAt?: Date;

  clientOnly_hasChanged?: boolean;

  constructor(data: SpotlightDTO) {
    this._id = data._id.toString();
    this.createdAt = data.createdAt;
    this.end = data.end;
    this.item = isObjectIdStringified(data.item)
      ? data.item.toString()
      : new PodcastEpisode(data.item as PodcastEpisodeDTO);
    this.start = data.start;
    this.type = data.type;
    this.uiConfig = data.uiConfig;
    this.updatedAt = data.updatedAt;
  }
}

export class SpotlightLink extends Spotlight implements SpotlightLinkEncodedDTO {
  preview?: SpotlightPreviewDTO;
  url: string;

  constructor(data: SpotlightLinkEncodedDTO) {
    super(data);
    this.preview = data.preview;
    this.url = data.url;
  }

  static fromJson(data?: SpotlightLinkEncodedDTO | null) {
    if (!data) return null;
    return new SpotlightLink(data);
  }
}
